import React from "react";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <div className="hero-section hs-1">
      <div
        className="hero-single"
        style={{ backgroundImage: "url(/assets/img/shape/01.png)" }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT CONTENT */}
            <div className="col-md-12 col-lg-6">
              <div className="hero-content">
                <h6 className="hero-sub-title wow fadeInUp" data-delay=".25s">
                  <i className="far fa-lightbulb-on"></i> Start To New Journey
                </h6>

                <h1 className="hero-title wow fadeInRight" data-delay=".50s">
                  Learn with Confidence.{" "}
                  <span className="text-gradient">Succeed with Excellence.</span>
                </h1>

                <p className="wow fadeInLeft" data-delay=".75s">
                  There are many variations of passages available but most have
                  suffered alteration in some form by injected humour.
                </p>

                <div className="hero-btn wow fadeInUp" data-delay="1s">
                  <Link to="/register" className="btn-accent">
                    Start Free Trial <i className="fas fa-arrow-right"></i>
                  </Link>

                  <Link to="/courses" className="theme-btn">
                    Browse Courses <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-md-12 col-lg-6">
              <div className="hero-visual">
                <div className="hero-info-wrap">
                  <div className="hero-avatar-group">
                    <h6>
                      <span>250k +</span> Students
                    </h6>
                    <span className="avatar">
                      <img src="/assets/images/small01.jpg" alt="" />
                    </span>
                    <span className="avatar">
                      <img src="/assets/images/small02.jpg" alt="" />
                    </span>
                    <span className="avatar">
                      <img src="/assets/images/small03.jpg" alt="" />
                    </span>
                    <span className="avatar">
                      <img src="/assets/images/small04.jpg" alt="" />
                    </span>
                    <span className="avatar">
                      <img src="/assets/images/small05.jpg" alt="" />
                    </span>
                  </div>

                  <div className="hero-course-info">
                    <div className="icon">
                      <img src="/assets/img/icon/course.svg" alt="" />
                    </div>
                    <h6 className="title">
                      <span>160+</span> Courses
                    </h6>
                  </div>
                </div>

                <div className="hero-img">
                  <img className="img-1" src="/assets/images/20.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
